"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }), " ", /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M0,3.00585866 C0,1.89805351 0.894513756,1 1.99406028,1 L14.0059397,1 C15.1072288,1 16,1.89706013 16,3.00585866 L16,12.9941413 C16,14.1019465 15.1054862,15 14.0059397,15 L1.99406028,15 C0.892771196,15 0,14.1029399 0,12.9941413 L0,3.00585866 Z M6,11 L6,5 L12,8 L6,11 Z"
  }), " ");
};

exports["default"] = _default;